import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function HookSection() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-brand-dark border-y border-slate-800/50" data-id="element-107">
      <div className="max-w-3xl mx-auto" data-id="element-108">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-brand-card rounded-2xl p-8 sm:p-12 border border-slate-800 relative overflow-hidden" data-id="element-109">
          {/* Decorative accent */}
          <div className="absolute top-0 left-0 w-1 h-full bg-brand-accent" data-id="element-110" />

          <h2 className="text-2xl sm:text-3xl font-serif font-bold text-white mb-8 leading-snug" data-id="element-111">
            Un sistema diseñado para tu realidad
          </h2>

          <div className="space-y-6 text-slate-300 text-lg leading-relaxed" data-id="element-112">
            <p data-id="element-113">
              Si has llegado hasta aquí, probablemente conoces esa sensación de
              que el dinero se escapa por{' '}
              <strong className="text-white font-semibold" data-id="element-114">
                "tuberías rotas"
              </strong>{' '}
              que no logras identificar.
            </p>
            <p data-id="element-115">
              Tal vez eres de los que siente que el mes se vuelve eterno al
              llegar al día 20, o quizás simplemente estás cansado de la
              ansiedad que genera no tener un plan claro para tu futuro.
            </p>

            <div className="flex items-start gap-4 bg-brand-dark/50 p-6 rounded-lg border border-slate-800 mt-8" data-id="element-116">
              <AlertCircle className="w-6 h-6 text-brand-accent shrink-0 mt-1" data-id="element-117" />
              <p className="text-white font-medium italic" data-id="element-118">
                El Método de George Capital Coaching no es un libro de economía;
                es el mapa exacto para detener las fugas, organizar tus ingresos
                y recuperar la paz mental que solo da el orden financiero total.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}